import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../../components/generic/Modal';
import { useDeleteParticipantFieldGroupTemplateMutation } from '../../../graphql/hooks/useDeleteParticipantFieldGroupTemplateMutation';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  participantFieldGroupTemplateId: string;
  onDelete: () => void;
}

export const ParticipantFieldGroupTemplateDeleteModal = createModal<Props>((props) => {
  const { participantFieldGroupTemplateId, onDelete, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteParticipantFieldGroupTemplateMutation({});
  const { hide, remove, visible } = modal;

  const onClick = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantFieldGroupTemplateId,
      })
      .then(async () => {
        hide();
        successToast('Participant field group template deleted successfully');
        onDelete();
      })
      .catch((err) => {
        errorToast(`Error deleting participant field group template: ${err.message}`);
      });
  }, [
    mutation,
    organization.id,
    participantFieldGroupTemplateId,
    hide,
    successToast,
    onDelete,
    errorToast,
  ]);

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle title='Do you want to delete this participant field group template?' />
          <ChakraV3.Dialog.Footer>
            <ChakraV3.HStack>
              <ChakraV3.Button onClick={hide} size='sm' variant='subtle'>
                Close
              </ChakraV3.Button>
              <ChakraV3.Button
                key='submit'
                colorPalette='red'
                loading={mutation.isLoading}
                loadingText='Deleting...'
                type='submit'
                onClick={onClick}
              >
                Delete
              </ChakraV3.Button>
            </ChakraV3.HStack>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
